import React, { useEffect } from "react";
import Heart from "../../../heart";
import DiscountTag from "../../../discounttag";
import NewCartButton from "../../../cartbutton/NewCartButton";

export default function Head(props) {
    let {
        title,
        subtitle,
        author,
        price,
        oldprice,
        owned,
        discount_type,
        discount_quantity,
        discount_postfix,
        point_quantity,
        point_discount_quantity,
        point_discount_postfix,
    } = props.data;
    let { bookId, upcoming } = props;

    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
    }, []);

    return (
        <div className="preview-header">
            <div className="inner">
                <div className="preview-details preview-ebook">
                    <div className="preview-title">
                        <span>{title}</span>
                        <div data-toggle="tooltip" title="Kívánságlistára">
                            <Heart
                                id={bookId}
                                wishlist
                                type="book"
                                style={{ height: 20, width: 20 }}
                            />
                        </div>
                    </div>
                    <div className="preview-subtitle">{subtitle}</div>
                    <div className="preview-author">
                        {author?.map((item, index) => (
                            <a href={item.url} key={index}>
                                {item.name}
                            </a>
                        ))}
                    </div>
                </div>
                {discount_type && (
                    <DiscountTag
                        type={discount_type}
                        quantity={discount_quantity}
                        postfix={discount_postfix}
                    />
                )}
                {discount_type && point_discount_quantity && (
                    <DiscountTag
                        type={"point"}
                        quantity={point_discount_quantity + point_discount_postfix}
                        postfix={"pont"}
                    />
                )}
                <div className="preview-price">
                    <span className="preview-old-price">{oldprice && `${oldprice} Ft`}</span>
                    <span className="preview-new-price">
                        {price && `${window.Dibook.language.formatCurrency(price)}`}
                    </span>
                    <span className="preview-point">
                        {!oldprice && point_quantity && `${Math.round(point_quantity)} Pont`}
                    </span>
                </div>
                {!upcoming && (
                    <div className="product-to-cart">
                        <NewCartButton id={bookId} owned={owned} full />
                    </div>
                )}
            </div>
        </div>
    );
}
